import { NotificationsCard } from "@components/Cards/NotificationsCard/NotificationsCard";

export const NotificationHistory = () => {
  return <NotificationsCard viewMode="history" />;
};
